import React, { FC, ReactNode } from "react";
import { Modal } from "@pd/pd-ui-kit";
import { useTranslation } from "react-i18next";

interface ConfirmModalProps {
  open: boolean;
  title?: string;
  text?: ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
  okText?: string;
  cancelText?: string;
  confirmLoading?: boolean;
  centered?: boolean;
  closable?: boolean;
  destroyOnHidden?: boolean;
}

export const ConfirmModal: FC<ConfirmModalProps> = ({
  open,
  title,
  text,
  onConfirm,
  onCancel,
  okText,
  cancelText,
  confirmLoading,
  centered,
  closable,
  destroyOnHidden,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      title={title ?? t("ui.confirm_action")}
      onCancel={onCancel}
      cancelButton={{ children: cancelText ?? t("ui.cancel") }}
      okButton={{
        children: okText ?? t("ui.delete"),
        onClick: onConfirm,
        loading: confirmLoading,
      }}
      centered={centered}
      closable={closable}
      destroyOnHidden={destroyOnHidden}
    >
      {text}
    </Modal>
  );
};
